import React from 'react';
import { SalesPage } from './pages/SalesPage';
interface AppProps {
  copiesLeft?: number;
  showStickyCta?: boolean;
  showPurchaseToasts?: boolean;
  showLiveViewers?: boolean;
}
export function App({
  copiesLeft = 13,
  showStickyCta = true,
  showPurchaseToasts = true,
  showLiveViewers = true
}: AppProps) {
  return <SalesPage copiesLeft={copiesLeft} showStickyCta={showStickyCta} showPurchaseToasts={showPurchaseToasts} showLiveViewers={showLiveViewers} data-id="element-0" data-mp="3fbt3gxsjud4a" />;
}